<template>
  <v-container>
    <div class="px-6">
      <h3 class="font-weight-bold">สร้างรายการขาย</h3>

      <v-sheet class="rounded-lg pa-4 my-5">
        <v-row>
          <v-col :cols="6" class="pr-4">
            <h4>ข้อมูล</h4>
            <v-row>
              <v-col :cols="6" align-self="center">ประเภท</v-col>
              <v-col :cols="5" align-self="center">ขายสินค้าออก</v-col>
            </v-row>
            <v-row>
              <v-col :cols="6" align-self="center">วันที่</v-col>
              <v-col :cols="5" align-self="center"></v-col>
            </v-row>
            <v-row>
              <v-col :cols="6" align-self="center">ช่องทางขาย</v-col>
              <v-col :cols="5" align-self="center">
                <v-select
                  dense
                  outlined
                  hide-details
                  :items="orderChannelList"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col :cols="6" class="pl-4">
            <h4>ลูกค้า</h4>
            <v-row>
              <v-col :cols="4" align-self="center">ชื่อ นามสกุล</v-col>
              <v-col :cols="6">
                <v-text-field hide-details dense outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="4" align-self="center">เบอร์โทร</v-col>
              <v-col :cols="6">
                <v-text-field hide-details dense outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="4" align-self="center">อีเมล</v-col>
              <v-col :cols="6">
                <v-text-field hide-details dense outlined> </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="4" align-self="center">อีเมล</v-col>
              <v-col :cols="6">
                <v-text-field hide-details dense outlined> </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet class="rounded-lg pa-4 my-5">
        <v-row>
          <v-col :cols="8" class="pr-4">
            <h4>สินค้า</h4>
            <v-simple-table striped>
              <thead style="font-weight:bold">
                <tr>
                  <td></td>
                  <td>ชื่อสินค้า</td>
                  <td>จำนวน</td>
                  <td>หมายเหตุ</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <v-btn depressed small>เลือก</v-btn>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col :cols="4" class="pr-4">
            <h4>สรุปรายการ</h4>
          </v-col>
        </v-row>
      </v-sheet>
    </div>
  </v-container>
</template>
<script>
import Service from "../../services";

import VLazyImage from "v-lazy-image";

export default {
  components: {
    VLazyImage,
  },
  data() {
    return {
      orderChannelList: [
        {
          text: "Facebook",
          vaulue: "facebook",
        },
        {
          text: "Line",
          vaulue: "line",
        },
      ],
      order: {
        basket: [],
      },
    };
  },
};
</script>
